// // // import React from 'react';
// // // import './CartPage.css';

// // // const CartPage = ({ cartItems, onRemoveFromCart, onUpdateQuantity, onClearCart, onBack, totalAmount }) => {
// // //   const formatPrice = (price) => {
// // //     if (!price) return '0 ₽';
// // //     const numericPrice = parseInt(price.replace(/\D/g, '')) || 0;
// // //     return numericPrice.toLocaleString() + ' ₽';
// // //   };

// // //   return (
// // //     <div className="cart-page">
// // //       <div className="cart-header">
// // //         <button className="back-btn" onClick={onBack}>← Назад</button>
// // //         <h2>Корзина</h2>
// // //         {cartItems.length > 0 && (
// // //           <button className="clear-cart-btn" onClick={onClearCart}>
// // //             Очистить корзину
// // //           </button>
// // //         )}
// // //       </div>

// // //       {cartItems.length === 0 ? (
// // //         <div className="empty-cart">
// // //           <svg className="empty-cart-icon" viewBox="0 0 24 24" width="64" height="64">
// // //             <path d="M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z" fill="#ccc"/>
// // //           </svg>
// // //           <p>Корзина пуста</p>
// // //           <button className="continue-shopping-btn" onClick={onBack}>
// // //             Закрыть корзину
// // //           </button>
// // //         </div>
// // //       ) : (
// // //         <>
// // //           <div className="cart-items">
// // //             {cartItems.map((item) => (
// // //               <div key={item.id} className="cart-item">
// // //                 <div className="cart-item-info">
// // //                   <h3>{item.name}</h3>
// // //                   {item.date && (
// // //                     <p className="cart-item-date">
// // //                       Дата: {item.date}
// // //                     </p>
// // //                   )}
// // //                   <p className="cart-item-price">
// // //                     {formatPrice(item.price)}
// // //                   </p>
// // //                 </div>
                
// // //                 <div className="cart-item-actions">
// // //                   <div className="quantity-controls">
// // //                     <button 
// // //                       className="quantity-btn"
// // //                       onClick={() => onUpdateQuantity(item.id, item.quantity - 1)}
// // //                     >
// // //                       -
// // //                     </button>
// // //                     <span className="quantity">{item.quantity}</span>
// // //                     <button 
// // //                       className="quantity-btn"
// // //                       onClick={() => onUpdateQuantity(item.id, item.quantity + 1)}
// // //                     >
// // //                       +
// // //                     </button>
// // //                   </div>
                  
// // //                   <button 
// // //                     className="remove-item-btn"
// // //                     onClick={() => onRemoveFromCart(item.id)}
// // //                     title="Удалить"
// // //                   >
// // //                     ✕
// // //                   </button>
// // //                 </div>
// // //               </div>
// // //             ))}
// // //           </div>

// // //           <div className="cart-footer">
// // //             <div className="cart-total">
// // //               <span>Итого:</span>
// // //               <span className="total-amount">{totalAmount.toLocaleString()} ₽</span>
// // //             </div>
            
// // //             <button className="checkout-btn">
// // //               Оформить запись
// // //             </button>
// // //           </div>
// // //         </>
// // //       )}
// // //     </div>
// // //   );
// // // };

// // // export default CartPage;



// // import React from 'react';
// // import './CartPage.css';

// // const CartPage = ({ cartItems, onRemoveFromCart, onUpdateQuantity, onClearCart, onBack }) => {
// //   const formatPrice = (price) => {
// //     if (!price) return '0 ₽';
// //     // Извлекаем число из строки (убираем все нецифровые символы кроме точки)
// //     const numericPrice = parseFloat(price.toString().replace(/[^\d.]/g, '')) || 0;
// //     return numericPrice.toLocaleString() + ' ₽';
// //   };

// //   // Функция для получения числового значения цены
// //   const getNumericPrice = (price) => {
// //     if (!price) return 0;
// //     return parseFloat(price.toString().replace(/[^\d.]/g, '')) || 0;
// //   };

// //   // Подсчет общей суммы с учетом количества
// //   const calculateTotalAmount = () => {
// //     return cartItems.reduce((total, item) => {
// //       const itemPrice = getNumericPrice(item.price);
// //       const quantity = item.quantity || 1;
// //       return total + (itemPrice * quantity);
// //     }, 0);
// //   };

// //   const totalAmount = calculateTotalAmount();

// //   // Обработчик изменения количества
// //   const handleQuantityChange = (itemId, newQuantity) => {
// //     if (newQuantity < 1) return;
// //     onUpdateQuantity(itemId, newQuantity);
// //   };

// //   return (
// //     <div className="cart-page">
// //       <div className="cart-header">
// //         <button className="back-btn" onClick={onBack}>← Назад</button>
// //         {/* <h2>Корзина</h2> */}
// //         {cartItems.length > 0 && (
// //           <button className="clear-cart-btn" onClick={onClearCart}>
// //             Очистить корзину
// //           </button>
// //         )}
// //       </div>

// //       {cartItems.length === 0 ? (
// //         <div className="empty-cart">
// //           <svg className="empty-cart-icon" viewBox="0 0 24 24" width="64" height="64">
// //             <path d="M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z" fill="#ccc"/>
// //           </svg>
// //           <p>Корзина пуста</p>
// //           <button className="continue-shopping-btn" onClick={onBack}>
// //             Продолжить покупки
// //           </button>
// //         </div>
// //       ) : (
// //         <>
// //           <div className="cart-items">
// //             {cartItems.map((item) => {
// //               const itemPrice = getNumericPrice(item.price);
// //               const quantity = item.quantity || 1;
// //               const itemTotal = itemPrice * quantity;
              
// //               return (
// //                 <div key={item.id} className="cart-item">
// //                   <div className="cart-item-info">
// //                     <h3>{item.name}</h3>
// //                     {item.date && (
// //                       <p className="cart-item-date">
// //                         📅 {item.date}
// //                       </p>
// //                     )}
// //                     <div className="cart-item-prices">
// //                       {/* <span className="cart-item-unit-price">
// //                         {formatPrice(item.price)} × {quantity}
// //                       </span> */}
// //                       <span className="cart-item-total-price">
// //                         {itemTotal.toLocaleString()} ₽
// //                       </span>
// //                     </div>
// //                   </div>
                  
// //                   <div className="cart-item-actions">
// //                     <div className="quantity-controls">
// //                       <button 
// //                         className="quantity-btn"
// //                         onClick={() => handleQuantityChange(item.id, quantity - 1)}
// //                         disabled={quantity <= 1}
// //                       >
// //                         -
// //                       </button>
// //                       <span className="quantity">{quantity}</span>
// //                       <button 
// //                         className="quantity-btn"
// //                         onClick={() => handleQuantityChange(item.id, quantity + 1)}
// //                       >
// //                         +
// //                       </button>
// //                     </div>
                    
// //                     <button 
// //                       className="remove-item-btn"
// //                       onClick={() => onRemoveFromCart(item.id)}
// //                       title="Удалить"
// //                     >
// //                       ✕
// //                     </button>
// //                   </div>
// //                 </div>
// //               );
// //             })}
// //           </div>

// //           <div className="cart-footer">
// //             <div className="cart-total">
// //               <span>Итого:</span>
// //               <span className="total-amount">{totalAmount.toLocaleString()} ₽</span>
// //             </div>
            
// //             <button className="checkout-btn">
// //               Оформить запись
// //             </button>
// //           </div>
// //         </>
// //       )}
// //     </div>
// //   );
// // };

// // export default CartPage;




// import React from 'react';
// import './CartPage.css';

// const CartPage = ({ cartItems, onRemoveFromCart, onUpdateQuantity, onClearCart, onBack, loading }) => {
//   const formatPrice = (price) => {
//     if (!price) return '0 ₽';
//     const numericPrice = parseFloat(price.toString().replace(/[^\d.]/g, '')) || 0;
//     return numericPrice.toLocaleString() + ' ₽';
//   };

//   const getNumericPrice = (price) => {
//     if (!price) return 0;
//     return parseFloat(price.toString().replace(/[^\d.]/g, '')) || 0;
//   };

//   const calculateTotalAmount = () => {
//     return cartItems.reduce((total, item) => {
//       const itemPrice = getNumericPrice(item.price);
//       const quantity = item.quantity || 1;
//       return total + (itemPrice * quantity);
//     }, 0);
//   };

//   const totalAmount = calculateTotalAmount();

//   const handleQuantityChange = (itemId, newQuantity) => {
//     if (newQuantity < 1) return;
//     onUpdateQuantity(itemId, newQuantity);
//   };

//   if (loading) {
//     return (
//       <div className="cart-page">
//         <div className="cart-header">
//           <button className="back-btn" onClick={onBack}>← Назад</button>
//         </div>
//         <div className="empty-cart">
//           <div className="loading-spinner-cart"></div>
//           <p>Загрузка корзины...</p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="cart-page">
//       <div className="cart-header">
//         <button className="back-btn" onClick={onBack}>← Назад</button>
//         {cartItems.length > 0 && (
//           <button className="clear-cart-btn" onClick={onClearCart}>
//             Очистить корзину
//           </button>
//         )}
//       </div>

//       {cartItems.length === 0 ? (
//         <div className="empty-cart">
//           <svg className="empty-cart-icon" viewBox="0 0 24 24" width="64" height="64">
//             <path d="M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z" fill="#ccc"/>
//           </svg>
//           <p>Корзина пуста</p>
//           <button className="continue-shopping-btn" onClick={onBack}>
//             Продолжить покупки
//           </button>
//         </div>
//       ) : (
//         <>
//           <div className="cart-items">
//             {cartItems.map((item) => {
//               const itemPrice = getNumericPrice(item.price);
//               const quantity = item.quantity || 1;
//               const itemTotal = itemPrice * quantity;
              
//               return (
//                 <div key={item.id} className="cart-item">
//                   <div className="cart-item-info">
//                     <h3>{item.name}</h3>
//                     {item.date && (
//                       <p className="cart-item-date">
//                         📅 {item.date}
//                       </p>
//                     )}
//                     <div className="cart-item-prices">
//                       <span className="cart-item-unit-price">
//                         {formatPrice(item.price)} × {quantity}
//                       </span>
//                       <span className="cart-item-total-price">
//                         {itemTotal.toLocaleString()} ₽
//                       </span>
//                     </div>
//                   </div>
                  
//                   <div className="cart-item-actions">
//                     <div className="quantity-controls">
//                       <button 
//                         className="quantity-btn"
//                         onClick={() => handleQuantityChange(item.id, quantity - 1)}
//                         disabled={quantity <= 1}
//                       >
//                         -
//                       </button>
//                       <span className="quantity">{quantity}</span>
//                       <button 
//                         className="quantity-btn"
//                         onClick={() => handleQuantityChange(item.id, quantity + 1)}
//                       >
//                         +
//                       </button>
//                     </div>
                    
//                     <button 
//                       className="remove-item-btn"
//                       onClick={() => onRemoveFromCart(item.id)}
//                       title="Удалить"
//                     >
//                       ✕
//                     </button>
//                   </div>
//                 </div>
//               );
//             })}
//           </div>

//           <div className="cart-footer">
//             <div className="cart-total">
//               <span>Итого:</span>
//               <span className="total-amount">{totalAmount.toLocaleString()} ₽</span>
//             </div>
            
//             <button className="checkout-btn">
//               Оформить запись
//             </button>
//           </div>
//         </>
//       )}
//     </div>
//   );
// };

// export default CartPage;




import React from 'react';
import './CartPage.css';

const CartPage = ({ cartItems, onRemoveFromCart, onUpdateQuantity, onClearCart, onBack, totalAmount, loading }) => {
  const formatPrice = (price) => {
    if (!price) return '0 ₽';
    const numericPrice = parseFloat(price.toString().replace(/[^\d.]/g, '')) || 0;
    return numericPrice.toLocaleString() + ' ₽';
  };

  const getNumericPrice = (price) => {
    if (!price) return 0;
    return parseFloat(price.toString().replace(/[^\d.]/g, '')) || 0;
  };

  const calculateTotalAmount = () => {
    return cartItems.reduce((total, item) => {
      const itemPrice = getNumericPrice(item.price);
      const quantity = item.quantity || 1;
      return total + (itemPrice * quantity);
    }, 0);
  };

  const finalTotal = totalAmount !== undefined ? totalAmount : calculateTotalAmount();

  const handleQuantityChange = (itemId, newQuantity) => {
    if (newQuantity < 1) return;
    onUpdateQuantity(itemId, newQuantity);
  };

  if (loading) {
    return (
      <div className="cart-page">
        <div className="cart-header">
          <button className="back-btn" onClick={onBack}>← Назад</button>
        </div>
        <div className="empty-cart">
          <div className="loading-spinner-cart"></div>
          <p>Загрузка корзины...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="cart-page">
      <div className="cart-header">
        <button className="back-btn" onClick={onBack}>← Назад</button>
        {cartItems.length > 0 && (
          <button className="clear-cart-btn" onClick={onClearCart}>
            Очистить корзину
          </button>
        )}
      </div>

      {cartItems.length === 0 ? (
        <div className="empty-cart">
          <svg className="empty-cart-icon" viewBox="0 0 24 24" width="64" height="64">
            <path d="M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z" fill="#ccc"/>
          </svg>
          <p>Корзина пуста</p>
          <button className="continue-shopping-btn" onClick={onBack}>
            Продолжить покупки
          </button>
        </div>
      ) : (
        <>
          <div className="cart-items">
            {cartItems.map((item) => {
              const itemPrice = getNumericPrice(item.price);
              const quantity = item.quantity || 1;
              const itemTotal = itemPrice * quantity;
              
              return (
                <div key={item.id} className="cart-item">
                  <div className="cart-item-info">
                    <h3>{item.name}</h3>
                    {item.date && (
                      <p className="cart-item-date">
                        📅 {item.date}
                      </p>
                    )}
                    {item.doctor && (
                      <p className="cart-item-doctor" style={{ fontSize: '12px', color: 'rgba(255,255,255,0.6)', marginTop: '4px' }}>
                        👨‍⚕️ {item.doctor}
                      </p>
                    )}
                    <div className="cart-item-prices">
                      <span className="cart-item-unit-price">
                        {formatPrice(item.price)} × {quantity}
                      </span>
                      <span className="cart-item-total-price">
                        {itemTotal.toLocaleString()} ₽
                      </span>
                    </div>
                  </div>
                  
                  <div className="cart-item-actions">
                    <div className="quantity-controls">
                      <button 
                        className="quantity-btn"
                        onClick={() => handleQuantityChange(item.id, quantity - 1)}
                        disabled={quantity <= 1}
                      >
                        -
                      </button>
                      <span className="quantity">{quantity}</span>
                      <button 
                        className="quantity-btn"
                        onClick={() => handleQuantityChange(item.id, quantity + 1)}
                      >
                        +
                      </button>
                    </div>
                    
                    <button 
                      className="remove-item-btn"
                      onClick={() => onRemoveFromCart(item.id)}
                      title="Удалить"
                    >
                      ✕
                    </button>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="cart-footer">
            <div className="cart-total">
              <span>Итого:</span>
              <span className="total-amount">{finalTotal.toLocaleString()} ₽</span>
            </div>
            
            <button className="checkout-btn">
              Оформить запись
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default CartPage;